import React, { useEffect, useState, useRef } from "react";
import "react-simple-keyboard/build/css/index.css";
//import { bannerList } from "../../config/game-configs";
import moment from "moment";
import useCountDown from 'react-countdown-hook';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PinInput from "react-pin-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Modal,
  ModalBody
} from "reactstrap";
import {
  setBusy,
  setIsShowCreateShareHolderPin,
  setIsShowCreateShareHolderPinPopup,
  setIsShowVerifyShareHolderPin,
  setIdle,
  showMessage,
  showResponseMessage
} from "../../redux/AppAction";
import { performLogin, updateUserIsCreateShareHolderPin } from "../../redux/AuthAction.js";
import { AlertTypes, ApiKey, ApiUrl, PhoneNumberPrefix, SessionKey, WebUrl, LanguageOption } from "../../util/Constant";
import ApiEngine from "./../../util/ApiEngine.js";
import {
  createFormBody,
  createMultiPartFormBody,
  stringIsNullOrEmpty
} from "./../../util/Util.js";


const ShareHolderAuth = () => {
  const { t, i18n } = useTranslation();
  const _history = useHistory();
  const _dispatch = useDispatch();

  const {
    handleSubmit,
    control,
    register,
    setValue,
    errors,
  } = useForm();

  var { isLoggedIn } = useSelector((state) => state.authState);
  const _userData = useSelector((state) => state.authState.userData);
  let isShowCreateShareHolderPin = useSelector((state) => state.appState.isShowCreateShareHolderPin);
  let isShowVerifyShareHolderPin = useSelector((state) => state.appState.isShowVerifyShareHolderPin);
  let isShowCreateShareHolderPinPopup = useSelector((state) => state.appState.isShowCreateShareHolderPinPopup);

  const [errorMessage, setErrorMessage] = useState("");
  // pin state

  const [theInterval, setTheInterval] = useState(false);
  const [invalidPin, setInvalidPin] = useState(false);
  const [pinNumber, setPinNumber] = useState("");
  const [enteredPinNumber, setEnteredPinNumber] = useState("");
  const [pinNumberFocused, setPinNumberFocused] = useState(0);
  const [pinNumberConfirm, setPinNumberConfirm] = useState("");
  const [enteredPinNumberConfirm, setEnteredPinNumberConfirm] = useState("");
  const [pinNumberConfirmFocused, setPinNumberConfirmFocused] = useState(0);
  const [pinNumberFinal, setPinNumberFinal] = useState("");
  const [enteredPinNumberFinal, setEnteredPinNumberFinal] = useState("");
  const [pinNumberFinalFocused, setPinNumberFinalFocused] = useState(0);
  const [smsSent, setSmsSent] = useState(false);
  const [countdownPeriod, setCountdownPeriod] = useState(0);
  const [showHpErrorMessage, setShowHpErrorMessage] = useState(false);
  const [hpErrorMessage, setHpErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [requestEnterPin, setRequestEnterPin] = useState(true);
  const _COUNTDOWN_PERIOD = 120;
  const _SECONDS_IN_MS = 1000;
  const _ALERT_TIMEOUT = 3000;

  const elePin = useRef(null);
  const eleConfirm = useRef(null);
  const eleFinalPin = useRef(null);



  const [isSendingPinCode, setIsSendingPinCode] = useState(false);




  //use effect function start region ---------------------------------------------------------------------

  //init
  useEffect(() => {
  }, []);



  //use effect function end region ---------------------------------------------------------------------


  //api function start region ---------------------------------------------------------------------

  function onCreatePinKeyPress(value) {
    // 1st: have to know if entering for elePin or eleConfirm
    // 2nd: have to know which index is currently focused for altering the state.value
    // 3rd: have to check if at elePin.index(3), if yes then convert value to string and focus on eleConfirm.index(0)
    // 4th: have to check if at eleConfirm.index(3), if yes then convert value to string, and submitPin

    let currentIndex = 0;
    let pinStr = enteredPinNumber;
    let pinConfirmStr = enteredPinNumberConfirm;
    if (value !== "{bksp}") {
      if (pinNumber === "") {
        currentIndex = pinNumberFocused;
        // elePin["current"]["elements"][currentIndex].state.value = value;
        pinStr = value;
        setEnteredPinNumber(pinStr);
        if (currentIndex !== 3) {
          currentIndex++;
          setPinNumberFocused(currentIndex);
          elePin["current"]["elements"][currentIndex].focus();
        } else {
          setPinNumber(pinStr);
        }
      } else {
        currentIndex = pinNumberConfirmFocused;
        // eleConfirm["current"]["elements"][currentIndex].state.value = value;
        pinConfirmStr = value;
        setEnteredPinNumberConfirm(pinConfirmStr);
        currentIndex++;
        setPinNumberConfirmFocused(currentIndex);
        if (currentIndex < 3) {
          eleConfirm["current"]["elements"][currentIndex].focus();
        } else {
          setPinNumberConfirm(pinConfirmStr);
          // setTimeout(function () {
          //   submitPin(pinNumber, pinConfirmStr);
          // }, 1000);
        }
      }
    } else {
      elePin["current"].clear();
      eleConfirm["current"].clear();
      setPinNumber("");
      setEnteredPinNumber("");
      setPinNumberFocused(currentIndex);
      setPinNumberConfirm("");
      setEnteredPinNumberConfirm("");
      setPinNumberConfirmFocused(currentIndex);
      elePin["current"]["elements"][currentIndex].focus();
    }
  }

  async function submitCreateShareHolderPin() {
    try {
      let params = {
        pinNumber: pinNumber,
        confirmPinNumber: pinNumberConfirm,
      };
      let responseJson = await ApiEngine.post(
        ApiUrl._API_SET_SHAREHOLDER_PIN_NUMBER,
        createFormBody(params)
      );
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        _dispatch(updateUserIsCreateShareHolderPin(false));
        _dispatch(setIsShowCreateShareHolderPin(false));
        setInvalidPin(false);
      }
      _dispatch(showMessage({
        type: AlertTypes._SUCCESS,
        content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
        onConfirm: () => {
          if (requestEnterPin) {
            _dispatch(setIsShowVerifyShareHolderPin(true));
          } else {
            setRequestEnterPin(true);
          }
        },
      }));

      elePin["current"].clear();
      eleConfirm["current"].clear();
      setPinNumber("");
      setEnteredPinNumber("");
      setPinNumberFocused(0);
      setPinNumberConfirm("");
      setEnteredPinNumberConfirm("");
      setPinNumberConfirmFocused(0);
    } catch (err) {
      _dispatch(showResponseMessage(false, err));
    }
  }

  function onVerifyPinKeyPress(value) {
    let currentIndex = 0;

    let pinStr = enteredPinNumberFinal;
    if (value !== "{bksp}") {
      if (pinNumberFinal === "") {
        currentIndex = pinNumberFinalFocused;
        // eleFinalPin["current"]["elements"][currentIndex].state.value = value;
        pinStr = value;
        setEnteredPinNumberFinal(pinStr);
        if (currentIndex !== 3) {
          currentIndex++;
          setPinNumberFinalFocused(currentIndex);
          eleFinalPin["current"]["elements"][currentIndex].focus();
        }
      }
    } else {
      eleFinalPin["current"].clear();
      setPinNumberFinal("");
      setEnteredPinNumberFinal("");
      setPinNumberFinalFocused(currentIndex);
      eleFinalPin["current"]["elements"][currentIndex].focus();
    }
  }

  const submitVerifyShareHolderPin = async () => {
    let params = {
      pinNumber: enteredPinNumberFinal,
    };
    let responseJson = await ApiEngine.post(
      ApiUrl._API_CHECK_SHAREHOLDER_PIN_NUMBER,
      createFormBody(params)
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      localStorage.setItem("6FAZhVi1QvBGsKaUl7WPhVTwRPf1HUhF", "wdAvBAPKCPB1TvXPsfPSda8PUUdEGaHg");
      setInvalidPin(false);
      _dispatch(setIsShowVerifyShareHolderPin(false));
      _history.push(WebUrl._URL_VIP);
    } else {
      localStorage.setItem("6FAZhVi1QvBGsKaUl7WPhVTwRPf1HUhF", "2vr5EqInInUuJj9LS0nK7e3hIfjKAGJv");
      setInvalidPin(true);
      setErrorMessage(responseJson[ApiKey._API_MESSAGE_KEY]);
      //eleFinalPin["current"].clear();
      setPinNumberFinal("");
      setEnteredPinNumberFinal("");
      setPinNumberFinalFocused(0);
      // eleFinalPin["current"]["elements"][0].focus();
    }
    // }
  };

  async function sendPinCode() {
    setIsSendingPinCode(true);
    if (countdownPeriod < 1) {
      let responseJson = await ApiEngine.get(
        ApiUrl._API_CHECK_IF_PHONE_VERIFIED
      );

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        setShowHpErrorMessage(false);
        var hpNum = responseJson[ApiKey._API_DATA_KEY];
        let params = {
          phoneNumber: hpNum,
          isShareholder: "true",
        };
        let smsJson = await ApiEngine.post(
          ApiUrl._API_SEND_PIN_CODE,
          createFormBody(params)
        );
        if (smsJson[ApiKey._API_SUCCESS_KEY]) {
          setSmsSent(true);
          setCountdownPeriod(_COUNTDOWN_PERIOD);
          setIsSendingPinCode(true);
        } else {
          setHpErrorMessage(smsJson[ApiKey._API_MESSAGE_KEY]);
          setShowHpErrorMessage(true);
          setIsSendingPinCode(true);
        }
      } else {
        setHpErrorMessage(responseJson[ApiKey._API_MESSAGE_KEY]);
        setShowHpErrorMessage(true);
        setIsSendingPinCode(true);
      }
    } else {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), [_ALERT_TIMEOUT]);
      setIsSendingPinCode(true);
    }
  }


  async function closeCreateShareHolderModal() {
    _dispatch(setIsShowCreateShareHolderPin(false));
    elePin["current"].clear();
    eleConfirm["current"].clear();
    setPinNumber("");
    setEnteredPinNumber("");
    setPinNumberFocused(0);
    setPinNumberConfirm("");
    setEnteredPinNumberConfirm("");
    setPinNumberConfirmFocused(0);
    setInvalidPin(false);
    setErrorMessage("")

  }

  async function closeVerifyShareHolderModal() {
    _dispatch(setIsShowVerifyShareHolderPin(false));
    eleFinalPin["current"].clear();
    setSmsSent(false);
    setCountdownPeriod(0);
    setShowHpErrorMessage(false);
    setHpErrorMessage("")
    setShowAlert(false);
    setPinNumberFinal("");
    setEnteredPinNumberFinal("");
    setPinNumberFinalFocused(0);
    setInvalidPin(false);
    setErrorMessage("")
    setIsSendingPinCode(false);

  }


  //normal function end region ---------------------------------------------------------------------


  return (
    <>
      <Modal
        contentClassName="shareholder-pin-modal"
        fade={false}
        isOpen={isLoggedIn && _userData.isShareHolder && _userData.isCreateShareHolderPin && isShowCreateShareHolderPin}
        toggle={() => closeCreateShareHolderModal()}
        centered
      >
        <ModalBody>
          <form onSubmit={handleSubmit(submitCreateShareHolderPin)}>
            <div className="shareholder-pin">
              <div>
                {t("SET_SHAREHOLDER_NEW_PIN")}
              </div>
              <div className="custom-pin-container mt-4 mb-4">
                <PinInput
                  length={4}
                  autocomplete="off"
                  initialValue=""
                  secret={true}
                  autoSelect={true}
                  disabled={false}
                  type="numeric"
                  inputMode="number"
                  regexCriteria={/^[ 0-9_@./#&+-]*$/}
                  onChange={(value, index) => {
                    setPinNumberFocused(index);
                    onCreatePinKeyPress(value);
                  }}
                  ref={elePin}
                  inputFocusStyle={{
                    borderBottom: "2px solid #FFC159",
                  }}

                />
              </div>
              <div>
                {t("CONFIRM_SHAREHOLDER_NEW_PIN")}
              </div>
              <div className="custom-pin-container mt-4">
                <PinInput
                  length={4}
                  autocomplete="off"
                  initialValue=""
                  secret={true}
                  autoSelect={true}
                  disabled={false}
                  type="numeric"
                  inputMode="number"
                  regexCriteria={/^[ 0-9_@./#&+-]*$/}
                  onChange={(value, index) => {
                    setPinNumberFocused(index);
                    onCreatePinKeyPress(value);
                  }}
                  ref={eleConfirm}
                  inputFocusStyle={{
                    borderBottom: "2px solid #FFC159",
                  }}

                />
              </div>
            </div>
            <br />
            <button type="submit" disabled={pinNumber.length !== 4 || pinNumberConfirm.length !== 4 || pinNumber !== pinNumberConfirm} className="custom-btn-style-1">
              {t("SUBMIT")}
            </button>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        contentClassName="shareholder-pin-modal"
        fade={false}
        isOpen={isLoggedIn && _userData.isShareHolder && !_userData.isCreateShareHolderPin && isShowVerifyShareHolderPin}
        toggle={() => closeVerifyShareHolderModal()}
        id="vip-pin-modal-new"
        centered
      >
        <ModalBody>
          <form onSubmit={handleSubmit(submitVerifyShareHolderPin)}>
            <div className="shareholder-pin">
              <div>
                {t("ENTER_YOUR_PIN")}
              </div>
              <div className="custom-pin-container mt-4">
                <PinInput
                  length={4}
                  autocomplete="off"
                  initialValue=""
                  secret={true}
                  autoSelect={true}
                  disabled={false}
                  type="numeric"
                  inputMode="number"
                  regexCriteria={/^[ 0-9_@./#&+-]*$/}
                  onChange={(value, index) => {
                    onVerifyPinKeyPress(value, index);
                  }}
                  ref={eleFinalPin}
                  inputFocusStyle={{
                    borderBottom: "2px solid #FFC159",
                  }}

                />
              </div>
            </div>
            <br />
            {smsSent & countdownPeriod > 0  ? (
              <p
                className="text-brand"
                style={{
                  textAlign: "center",
                  marginTop: "5px",
                }}
              >
                {t("PIN_SENT")} {t("RESEND_IN")} {countdownPeriod}{" "} {t("SECOND")}
              </p>
            ) : (
              <strong
                className="text-brand display-value"
                style={{ cursor: "pointer", paddingTop: '30px' }}
                  onClick={() => {
                    if (!isSendingPinCode) {
                      sendPinCode();
                    }
                }}
              >
                  {isSendingPinCode ? t("SENDING_PIN") : t("RESET_PIN")}
              </strong>
            )}
            {showAlert && (
              <div
                className="content content-full-width"
                style={{
                  position: "fixed",
                  top: "10px",
                  left: "0",
                  width: "100%",
                  zIndex: 9999,
                }}
              >
                <div className="container">
                  <Alert color="danger">
                    {t("WAIT_TO_RESEND")}
                  </Alert>
                </div>
              </div>
            )}
            {showHpErrorMessage && (
              <p
                className="text-brand text-red"
                style={{ textAlign: "center", marginTop: "5px" }}
              >
                {t(hpErrorMessage)}
              </p>
            )}
            <div
              className="invalid-feedback"
              style={{ fontSize: "12px", marginTop: "1rem" }}
            >
              {invalidPin &&
                <div className="invalid-feedback" style={{ fontSize: "12px", marginTop: "1rem" }}>
                  {t(errorMessage)}
                </div>
              }
            </div>


            <button type="submit" disabled={enteredPinNumberFinal.length != 4} className="custom-btn-style-1">
              {t("SUBMIT")}
            </button>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        fade={true}
        contentClassName="modal"
        id="success-modal"
        isOpen={isLoggedIn && _userData.isShareHolder && _userData.isCreateShareHolderPin && isShowCreateShareHolderPinPopup}
        centered
        toggle={() => {
          _dispatch(setIsShowCreateShareHolderPinPopup(false));
        }}
      >
        <ModalBody>

          <div className="edit-vt-data" style={{ padding: '20px' }}>
            <div className="text-white text-center" style={{ fontSize: "24px" }}>{t("SHAREHOLDER_PIN_SETUP_TITLE")}</div>
            <div>
              <div className="mt-4 text-center">
                {t("SHAREHOLDER_PIN_SETUP_MESSAGE")}
              </div>
              <button className="btn custom-btn-style-2 w-100 mt-4" style={{ color: "#000", background: "rgba(253, 190, 47, 1)" }} onClick={() => {
                setRequestEnterPin(false);
                _dispatch(setIsShowCreateShareHolderPin(true));
              }}>{t("SETUP_PIN")}</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ShareHolderAuth;
